import React from 'react';
import { ErrorReportingContext, ErrorBoundary } from '@cko/dashboard-shared';
import { datadogRum } from '@datadog/browser-rum';
import { ReactNode } from 'react';

export const ErrorReportingProvider = (props: { children: ReactNode }) => {
  return (
    <ErrorReportingContext.Provider value={{ datadog: datadogRum }}>
      <ErrorBoundary>{props.children}</ErrorBoundary>
    </ErrorReportingContext.Provider>
  );
};
